import { cn } from "@/lib/utils";

// Status pill using design tokens only (no hardcoded colors).
const VARIANTS = {
  connected: "bg-success/15 text-success border-success/20",
  active: "bg-success/15 text-success border-success/20",
  published: "bg-success/15 text-success border-success/20",
  approved: "bg-success/15 text-success border-success/20",
  received: "bg-brand/15 text-brand border-brand/20",
  requested: "bg-warning/15 text-warning border-warning/20",
  scheduled: "bg-brand/15 text-brand border-brand/20",
  queued: "bg-muted text-muted-foreground border-border",
  running: "bg-warning/15 text-warning border-warning/20",
  retrying: "bg-warning/15 text-warning border-warning/20",
  succeeded: "bg-success/15 text-success border-success/20",
  dead_letter: "bg-destructive/15 text-destructive border-destructive/20",
  publishing: "bg-warning/15 text-warning border-warning/20",
  paused: "bg-warning/15 text-warning border-warning/20",
  pending: "bg-warning/15 text-warning border-warning/20",
  pending_auth: "bg-warning/15 text-warning border-warning/20",
  draft: "bg-muted text-muted-foreground border-border",
  ready_for_review: "bg-warning/15 text-warning border-warning/20",
  executed: "bg-brand/15 text-brand border-brand/20",
  in_progress: "bg-warning/15 text-warning border-warning/20",
  completed: "bg-success/15 text-success border-success/20",
  archived: "bg-muted text-muted-foreground border-border",
  cancelled: "bg-muted text-muted-foreground border-border",
  disconnected: "bg-muted text-muted-foreground border-border",
  error: "bg-destructive/15 text-destructive border-destructive/20",
  rejected: "bg-destructive/15 text-destructive border-destructive/20",
  failed: "bg-destructive/15 text-destructive border-destructive/20",
  info: "bg-brand/15 text-brand border-brand/20",
};

const DOT = {
  connected: "bg-success", active: "bg-success", published: "bg-success", approved: "bg-success",
  received: "bg-brand", requested: "bg-warning",
  scheduled: "bg-brand", publishing: "bg-warning",
  queued: "bg-muted-foreground", running: "bg-warning", retrying: "bg-warning",
  succeeded: "bg-success", dead_letter: "bg-destructive",
  paused: "bg-warning", pending: "bg-warning", pending_auth: "bg-warning",
  draft: "bg-muted-foreground", archived: "bg-muted-foreground", cancelled: "bg-muted-foreground",
  ready_for_review: "bg-warning", executed: "bg-brand", in_progress: "bg-warning", completed: "bg-success",
  disconnected: "bg-muted-foreground",
  error: "bg-destructive", rejected: "bg-destructive", failed: "bg-destructive", info: "bg-brand",
};

export function StatusBadge({ status = "draft", label, dot = true, className, ...props }) {
  const key = String(status).toLowerCase();
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize",
        VARIANTS[key] || VARIANTS.draft,
        className,
      )}
      data-testid={props["data-testid"] || `status-${key}`}
    >
      {dot && <span className={cn("h-1.5 w-1.5 rounded-full", DOT[key] || DOT.draft)} />}
      {label || String(status).replace(/_/g, " ")}
    </span>
  );
}

export function StatusDot({ status = "disconnected", className }) {
  const key = String(status).toLowerCase();
  return (
    <span className={cn("relative inline-flex h-2 w-2", className)}>
      {(key === "connected" || key === "active") && (
        <span className={cn("absolute inline-flex h-full w-full animate-ping rounded-full opacity-60", DOT[key])} />
      )}
      <span className={cn("relative inline-flex h-2 w-2 rounded-full", DOT[key] || DOT.disconnected)} />
    </span>
  );
}
